// Écran Caisse (journal de trésorerie espèces — compte 530000).
import React from "react";
import { Wallet } from "lucide-react";
import SaisieTresorerie from "@/components/SaisieTresorerie";

export default function Caisse() {
  return (
    <SaisieTresorerie
      config={{
        journal: "caisse",
        titre: "Caisse",
        sousTitre: "Enregistrez les encaissements et décaissements d'espèces.",
        icone: Wallet,
        moyensPaiement: ["Espèces"],
        pageTestId: "page-caisse",
        arrete: true,
        journalCode: "CA",
        libelleJournal: "CA — Caisse",
        compteTresorerie: "530000",
      }}
    />
  );
}
